import React from 'react'
import "./endoscopes.css"
import CustomTitle from '../CustomTitle/CustomTitle.jsx'








export default function Endoscopes() {

   return (
      <>
         <div className="container">
            <CustomTitle title="صفحة المناظير" />

            <h2 className='main-header mt-5 pt-5'>Endoscopes Profile</h2>
            <div className='under-header'></div>

            <div className="row">
               <p>Not Found Data Today`s !</p>
            </div>
         </div>
      </>
   )
}
